const NOTIFICATION_LIST_PATH = (childId, isAParent) =>
  `/child/${childId}/get_notification_list/?isParent=${isAParent}`;

const MARK_NOTIFICATION_AS_READ = (notificationId) => `/notification/${notificationId}/mark_read/`;

const MARK_ALL_NOTIFICATIONS_AS_READ = (childId) => `/child/${childId}/NotificationMarkAllAsRead/`;

const ACCEPT_OR_REJECT_ITEM = (id) => `/point/${id}/activate/`;

export default {
  NOTIFICATION_LIST_PATH,
  MARK_NOTIFICATION_AS_READ,
  MARK_ALL_NOTIFICATIONS_AS_READ,
  ACCEPT_OR_REJECT_ITEM,
};
